// extracted by mini-css-extract-plugin
export default {"headerSection":"DeletedTable_headerSection__ZP5em","title":"DeletedTable_title__Y+VWW","warningText":"DeletedTable_warningText__KBoG-"};